export const MAP_EDITS_FETCHED = 'MAP_EDITS_FETCHED';
